<div class="filtr-wrap">
  <h3 class="fltr-head">
    <span *ngIf="flag">Applied</span> Filter
    <ng-container *ngIf="flag">
      <button class="mat-clear-fltr text-danger" mat-icon-button (click)="fn_ClearFilter()">
        <i class="fa fa-refresh" aria-hidden="true" style="vertical-align: initial;"></i>
        Reset
      </button>
      <small>
        <br />
        <br />
        <span *ngIf="showCategories.length>0"><strong>Category: </strong> {{showCategories}}<br /></span>
        <span *ngIf="showBrand.length>0"><strong>Brand: </strong> {{showBrand}}<br /></span>
        <span *ngIf="showSize.length>0"><strong>Size: </strong> {{showSize}}<br /></span>
        <span *ngIf="showColor.length>0"><strong>Color: </strong> {{showColor}}<br /></span>
        <span *ngIf="showPrintLocation.length>0"><strong>Print location: </strong> {{showPrintLocation}}<br /></span>
      </small>
    </ng-container>

  </h3>
  <!--Category and Sub-Category Filter-->
  <nav>
    <ul class="nav">
      <li class="cat-blk-act">
        <a href="#" data-toggle="collapse" class="in" aria-expanded="true">
          Decoration
        </a>
        <div class="sb-ct-sbmn">
          <ul class="nav collapse show" role="menu">
            <li *ngFor="let dec of decorationTypes">
              <span class="dec-type">
                <input
                  type="checkbox"
                  [checked]="fn_IsDecorationSelected(dec.Name)"
                  (change)="fn_ToggleDecorationType(dec.Name)"
                >&nbsp;{{dec.Name}}
              </span>
            </li>
            <li *ngIf="decorationTypes.length === 0">
              <span class="dec-type" style="color:#999">Loading…</span>
            </li>
          </ul>
        </div>
      </li>
      <li class="cat-blk-act">
        <a href="#" id="btn-1" data-toggle="collapse" class="in" data-target="#submenu1" aria-expanded="false">
          Category
          <span class="mat-expansion-indicator ctg-exp pull-right"></span>
        </a>
        <div class="sb-ct-sbmn">
          <ul class="nav collapse show" id="submenu1" role="menu" aria-labelledby="btn-1"
              *ngFor="let category of filterList.Categories ; let i = index">
            <li>
              <a class="collapsed" style="cursor:pointer"
                 (click)="category.SubCategories.length == 0? fn_SelectCategory(category.ID, true): '' "
                 data-toggle="collapse" [attr.data-target]="'#cat' + i" aria-expanded="false">
                {{category.Name}}
                <svg *ngIf="category.SubCategories.length" class="svg-ct-arw" version="1.1"
                     xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129" xmlns:xlink="http://www.w3.org/1999/xlink"
                     enable-background="new 0 0 129 129">
                  <g>
                    <path d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z" />
                  </g>
                </svg>

              </a>
              <ul class="nav collapse" id="cat{{i}}" role="menu" aria-labelledby="btn-1"
                  *ngFor="let subcategory of category.SubCategories">
                <li>
                  <a style="cursor: pointer; color: #a59f9f !important " (click)="fn_SelectCategory(subcategory.ID, false)">
                    <i class="fa fa-level-up" aria-hidden="true"></i>
                    {{subcategory.Name}}
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </nav>
  <!-- Brand -->
  <mat-accordion>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          Brand
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ul>
        <li>
          <input type="text" class="form-control" placeholder="Search..." [(ngModel)]="searchBrand">
        </li>
        <ng-container *ngIf="(filterList.Brands | filter : searchBrand : 'Manufacturer') as result">
          <li *ngFor="let brand of result">
            <mat-checkbox #brandCheckbox [(ngModel)]="brand.checked" [checked]="brand.checked" (change)="fn_SelectBrand($event, brand.ManufacturerId,brand.Manufacturer)">
              {{brand.Manufacturer}}
            </mat-checkbox>
          </li>
          <span *ngIf="!result.length" class="text-center">No brands found</span>
        </ng-container>
      </ul>
    </mat-expansion-panel>
  </mat-accordion>

  <!-- Size -->
  <mat-accordion>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          Size
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ul>
        <li>
          <input type="text" class="form-control" placeholder="Search..." [(ngModel)]="searchSize">
        </li>
        <ng-container *ngIf="(filterList.Sizes | filter : searchSize) as result">
          <li *ngFor="let size of result">
            <mat-checkbox #sizeCheckbox (change)="fn_SelectSize($event, size)">
              {{size}}
            </mat-checkbox>
          </li>
          <span *ngIf="!result.length" class="text-center">No sizes found</span>
        </ng-container>
      </ul>
    </mat-expansion-panel>
  </mat-accordion>

  <!-- Color -->
  <mat-accordion>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          Color
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ul>
        <li>
          <input type="text" class="form-control" placeholder="Search..." [(ngModel)]="searchColor">
        </li>
        <ng-container *ngIf="(filterList.Colors | filter : searchColor : 'ColorName') as result">
          <li *ngFor="let color of result">
            <mat-checkbox #colorCheckbox [(ngModel)]="color.checked" [checked]="color.checked" (change)="fn_SelectColor($event, color.ColorName)">
              &nbsp;<span [style.backgroundColor]="fetchColor(color.ColorHexCode)" style="border:1px solid #808080">
                &nbsp;&nbsp;&nbsp;&nbsp;
              </span>&nbsp;{{color.ColorName | titlecase }}
            </mat-checkbox> &nbsp;
          </li>
          <span *ngIf="!result.length" class="text-center">No colors found</span>
        </ng-container>
      </ul>
    </mat-expansion-panel>
  </mat-accordion>

  <!-- Print location -->
  <mat-accordion>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          Print location
          <span class="fltr-new-badge">NEW</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ul>
        <li>
          <input type="text" class="form-control" placeholder="Search..." [(ngModel)]="searchPrintLocation">
        </li>
        <ng-container *ngIf="(filterList.PrintLocations | filter : searchPrintLocation : 'Description') as result">
          <li *ngFor="let loc of result">
            <mat-checkbox #printLocationCheckbox [(ngModel)]="loc.checked" [checked]="loc.checked"
                          (change)="fn_SelectPrintLocation($event, loc.ImpressDecorationLocationCodeId, loc.Description)">
              Has {{loc.Description}} template
            </mat-checkbox>
          </li>
          <span *ngIf="!result.length" class="text-center">No print locations found</span>
        </ng-container>
      </ul>
    </mat-expansion-panel>
  </mat-accordion>
</div>
